



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// approvePurchase
// APPROVEPURCHASE


const APPROVEPURCHASE= createAsyncThunk(
  "approvePurchase/approvePurchase",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const approvePurchaseSlice = createSlice({
  name: "approvePurchaseSlice",
  initialState: {
    approvePurchase: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfapprovePurchase: (state) => {
        state.approvePurchase.loading = false
        state.approvePurchase.error = false
        state.approvePurchase.data = []
        state.approvePurchase.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(APPROVEPURCHASE.fulfilled, (state, action) => {
      state.approvePurchase = {
        ...state.approvePurchase,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEPURCHASE.pending, (state, action) => {
      state.approvePurchase = {
        ...state.approvePurchase,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEPURCHASE.rejected, (state, action) => {
      state.approvePurchase = {
        ...state.approvePurchase,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const approvePurchaseAction = {
    APPROVEPURCHASE,
};

export { approvePurchaseAction };
export default approvePurchaseSlice.reducer;
export const {setInitialStateOfapprovePurchase} = approvePurchaseSlice.actions
